// extracted by mini-css-extract-plugin
module.exports = {"container":"bz","productName":"cz","modal":"dz","dimensions":"ez","recipientEmail":"fz","lowStock":"gz","recommendedFit":"hz"};